<div class="tree-view"
     *ngIf="!isLoaded">
    Vide
</div>
<div class="tree-view"
     *ngIf="isLoaded">
    <ng-container *ngTemplateOutlet="treeViewList; context:{ $implicit: treeModel.items, role: 'tree', treeid: treeModel.treeNodeId, parentid: 'root', lid: 0 }">
    </ng-container>
</div>
<ng-template #treeViewList
             let-list
             let-role='role'
             let-treeid="treeid"
             let-parentid="parentid"
             let-lid="lid">
    <ul [attr.role]="role"
        id="treeView_ul_{{treeid}}_{{parentid}}"
        [attr.aria-labelledby]="this['tree_view_'+treeid]"
        *ngIf="isChildrenExists(list)"
        #ultags>
        <li *ngFor="let item of list;let i=index"
            [id]="getTreeItemId(item,treeid)"
            [attr.data-code]="item[treeModel.cid]"
            [attr.data-childcount]="getChildCount(item)"
            [attr.data-index]="i"
            [attr.data-first]="i === 0 ? 1 : 0"
            [attr.data-last]="i === list.length - 1 ? 1 : 0"
            role="treeitem"
            (keydown)="executeKeydown($event)"
            [tabindex]="setTabIndexOnLoad(role,i)"
            #options
            [attr.aria-expanded]="collapsedState(item)">
            <span class="tree-item-label"
                  [class.hover]="isLeaf(item) && hoverLeaves"
                  [attr.data-role]="isLeaf(item) ? 'leaf' : role"
                  (click)="toggleNode(item)"
                  (mouseenter)="onMouseenter(item)"
                  (mouseleave)="onMouseleave(item)">
                <i *ngIf="!isLeaf(item)"
                   aria-hidden="true"
                   [ngClass]="getExpandCollapseClass(item)"
                   [id]="getIconId(item)"
                   #icons>
                </i>
                <i *ngIf="isLeaf(item) && getLeafClass(item)"
                   aria-hidden="true"
                   [ngClass]="getLeafClass(item)"
                   [id]="getIconId(item)"
                   #icons>
                </i>
                <ng-container *ngIf="hasTemplate(item); else basicItem">
                    <ng-container *ngTemplateOutlet="getTemplate(item); context:{ $implicit: item.data}">
                    </ng-container>
                </ng-container>
                <ng-template #basicItem>
                    {{item[treeModel.lid]}}
                </ng-template>
            </span>
            <ng-container *ngTemplateOutlet="treeViewList; context:{ $implicit: item.children, role: 'group', treeid: treeModel.treeNodeId, parentid: item[treeModel.cid], lid: lid + 1 }">
            </ng-container>
        </li>
    </ul>
</ng-template>
